import vv_utils from './vv_utils';
import {redirectRequest} from "./vv_c";

const socialLoginUser = (userstate) => {
  return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/social/login`, userstate, 'POST', vv_utils.defaultTimeout);
}

const socialSignupUser = (userstate) => {
  return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/social/signup`, userstate, 'POST', vv_utils.defaultTimeout);
}

const passwordLoginUser = (userstate) => {
  return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/password/login`, userstate,'POST', vv_utils.defaultTimeout);
}

const { createMachine, interpret , assign} = window.XState;

const promiseMachine = createMachine({
  id: 'promise',
  initial: 'loading',
  states: {
    loading: {
      on: {
          LOAD_COMPLETE: { target: 'firstready' },   
      }
    },
    firstready: {
      entry: 'loaded',
      on: {
          INPUT: { 
            target: 'filling',
            actions: (context, event) => {  }
          },
          CHANGE: { 
            target: 'filling',
            actions: (context, event) => {  }
          },
          SUBMIT: { target: 'insubmission'},
          PERFORM_ACTION: { target: 'inaction' },
          OVERRIDE: { target: 'override' }
      }
    },
    filling: {
      entry: 'message',
      on: {
        SUBMIT: { target: 'insubmission'},
        OVERRIDE: { target: 'override' }
      }
    },
    insubmission: {
      entry: 'validate',
      on: {
        VALIDATION_SUCCESS: { target: 'valid' },
        VALIDATION_FAILURE: { target: 'invalid'}
      }
    },
    invalid: {
      entry: 'validationFailed',
      on: {
        CHANGE: { target: 'filling' },
        INPUT: { target: 'filling' },
        OVERRIDE: { target: 'override' }
      }
    },
    valid: {
      entry: 'validationSucceeded',
      on: {
        PERFORM_ACTION: { target: 'inaction' }
      }
    },
    override: {
      on: {
        PERFORM_ACTION: { target: 'inaction' }
      }
    },
    inaction: {
      entry: 'performAction',
      on: {
        ACTION_SUCCESS: { target: 'succeeded' },
        ACTION_FAILURE: { target: 'failed' }
      }
    },
    failed: {
      entry: 'actionFailed',
      on: {
        VALIDATION_FAILURE: { target: 'invalid'},
        CHANGE: { target: 'filling' },
        INPUT: { target: 'filling' },        
        SUBMIT: { target: 'insubmission'},
        PERFORM_ACTION: { target: 'inaction' }
      }
    },
    succeeded: {
      entry: 'actionSucceeded',
      on: {
        LOAD_COMPLETE: { target: 'firstready' },   
      },
    },
    complete: {
      entry: 'final',
      type: 'final'
    }    
  }
},
{
  actions: {
    loaded: () => {},
    message: () => {},
    validate: () => {},
    validationFailed: () => {},
    validationSucceeded: () => {},
    performAction: () => {},
    actionFailed: () => {},
    actionSucceeded: () => {},
    final: () => {},
  }
});

const invokeMachine = createMachine({
  id: 'invoke',
  initial: 'loading',
  context: {
    error: undefined
  },
  states: {
    loading: {
      on: {
          LOAD_COMPLETE: { target: 'firstready' },   
      }
    },
    firstready: {
      entry: 'loaded',
      on: {
          INPUT: { 
            target: 'filling',
            actions: (context, event) => {  }
          },
          CHANGE: { 
            target: 'filling',
            actions: (context, event) => {  }
          },
          SUBMIT: { target: 'insubmission'},
          PERFORM_ACTION: { target: 'inaction' },
          OVERRIDE: { target: 'override' }
      }
    },
    filling: {
      entry: 'message',
      on: {
        SUBMIT: { target: 'insubmission'},
        OVERRIDE: { target: 'override' }
      }
    },
    insubmission: {
      invoke: {
        id: 'validate',
        src: 'validate_service',
        onDone: {
          target: 'valid',
          actions: (context, event) => {  }
        },
        onError: {
          target: 'invalid',
          actions: assign({ error: (context, event) => event.data })
        }
      }
    },
    invalid: {
      entry: 'validationFailed',
      on: {
        CHANGE: { target: 'filling' },
        INPUT: { target: 'filling' },
        OVERRIDE: { target: 'override' }
      }
    },
    valid: {
      entry: 'validationSucceeded',
      on: {
        PERFORM_ACTION: { target: 'inaction' }
      }
    },
    override: {
      on: {
        PERFORM_ACTION: { target: 'inaction' }
      }
    },
    inaction: {
      entry: 'performAction',
      on: {
        ACTION_SUCCESS: { target: 'succeeded' },
        ACTION_FAILURE: { target: 'failed' }
      }
    },
    failed: {
      entry: 'actionFailed',
      on: {
        VALIDATION_FAILURE: { target: 'invalid'},
        CHANGE: { target: 'filling' },
        INPUT: { target: 'filling' },        
        SUBMIT: { target: 'insubmission'},
        PERFORM_ACTION: { target: 'inaction' }
      }
    },
    succeeded: {
      entry: 'actionSucceeded',
      on: {
        LOAD_COMPLETE: { target: 'firstready' },   
      },
    },
    complete: {
      entry: 'final',
      type: 'final'
    }    
  }
},
{
  actions: {
    loaded: () => {},
    message: () => {},
    validationFailed: () => {},
    validationSucceeded: () => {},
    performAction: () => {},
    actionFailed: () => {},
    actionSucceeded: () => {},
    final: () => {},
  },
  services: {
    validate_service: () => {},
  }
}
);

const simpleInvokeMachine = createMachine({
  id: 'simpleInvoke',
  initial: 'idle',
  context: {
    data: undefined,
    error: undefined
  },
  states: {
    idle: {
      on: {
        FETCH: { target: 'inaction' },   
      }
    },
    inaction: {
      invoke: {
        id: 'action',
        src: 'action_service',
        onDone: {
          target: 'succeeded',
          actions: assign({
            data: (context, event)=> event.data,
            error: ()=> undefined
          })
        },
        onError: {
          target: 'failed',
          actions: assign({error: (context, event)=> event.data})
        }
      }
    },
    failed: {
      entry: 'actionFailed',
      on: {
        FETCH: { target: 'inaction' }
      }
    },
    succeeded: {
      entry: 'actionSucceeded',
      on: {
        IDLE: { target: 'idle' },   
      },
    },
    complete: {
      entry: 'final',
      type: 'final'
    }    
  }
},
{
  actions: {
    actionFailed: () => {},
    actionSucceeded: () => {},
    final: () => {},
  },
  services: {
    action_service: () =>{},
  }
}
);

const fullInvokeMachine = createMachine({
  id: 'validate_invoke',
  initial: 'loading',
  context: {
    data: undefined,
    error: undefined
  },
  states: {
    loading: {
      entry: 'loading',
      on: {
          LOAD_COMPLETE: { target: 'firstready' },   
      }
    },
    firstready: {
      entry: 'loaded',
      on: {
          INPUT: { 
            target: 'filling',
            actions: (context, event) => {  }
          },
          CHANGE: { 
            target: 'filling',
            actions: (context, event) => {  }
          },
          SUBMIT: { target: 'insubmission'},
          PERFORM_ACTION: { target: 'inaction' },
          OVERRIDE: { target: 'override' }
      }
    },
    filling: {
      entry: 'message',
      on: {
        SUBMIT: { target: 'insubmission'},
        OVERRIDE: { target: 'override' }
      }
    },
    insubmission: {
      invoke: {
        id: 'validate',
        src: 'validate_service',
        onDone: {
          target: 'valid',
          actions: (context, event) => {  }
        },
        onError: {
          target: 'invalid',
          actions: assign({ error: (context, event) => event.data })
        }
      }
    },
    invalid: {
      entry: 'validationFailed',
      on: {
        CHANGE: { target: 'filling' },
        INPUT: { target: 'filling' },
        OVERRIDE: { target: 'override' }
        //CLOSE:  
        //check bootstrap to know what event gets called when a modal closes 
      }
    },
    valid: {
      entry: 'validationSucceeded',
      on: {
        PERFORM_ACTION: { target: 'inaction' }
      }
    },
    override: {
      on: {
        PERFORM_ACTION: { target: 'inaction' }
      }
    },
    inaction: {
      invoke: {
        id: 'action',
        src: 'action_service',
        onDone: {
          target: 'succeeded',
          actions: assign({
            data: (context, event)=> event.data,
            error: ()=> undefined
          })
        },
        onError: {
          target: 'failed',
          actions: assign({error: (context, event)=> event.data})
        }
      }
    },
    failed: {
      entry: 'actionFailed',
      on: {
        VALIDATION_FAILURE: { target: 'invalid'},
        CHANGE: { target: 'filling' },
        INPUT: { target: 'filling' },        
        SUBMIT: { target: 'insubmission'},
        PERFORM_ACTION: { target: 'inaction' }
      }
    },
    succeeded: {
      entry: 'actionSucceeded',
      on: {
        LOAD_COMPLETE: { target: 'firstready' },   
      },
    },
    complete: {
      entry: 'final',
      type: 'final'
    }    
  }
},
{
  actions: {
    loaded: () => {},
    message: () => {},
    validationFailed: () => {},
    validationSucceeded: () => {},
    performAction: () => {},
    actionFailed: () => {},
    actionSucceeded: () => {},
    final: () => {},
  },
  services: {
    validate_service: () => {},
    action_service: () =>{},
  }
}
);

const fullLoadingInvokeMachine = createMachine({
  id: 'validate_invoke',
  initial: 'init',
  context: {
    data: undefined,
    error: undefined
  },
  states: {
    init: {
      on: {
          INIT_COMPLETE: { target: 'loading' },   
      }
    },    
    loading: {
      invoke: {
        id: 'loading',
        src: 'loading_service',
        onDone: {
          target: 'firstready',
          actions: assign({
            data: (context, event)=> event.data,
            error: ()=> undefined
          })
        },
        onError: {
          target: 'invalid',
          actions: assign({ error: (context, event) => event.data })
        }
      }      
    },
    firstready: {
      entry: 'loaded',
      on: {
          INPUT: { 
            target: 'filling',
            actions: (context, event) => {  }
          },
          CHANGE: { 
            target: 'filling',
            actions: (context, event) => {  }
          },
          SUBMIT: { target: 'insubmission'},
          PERFORM_ACTION: { target: 'inaction' },
          OVERRIDE: { target: 'override' }
      }
    },
    filling: {
      entry: 'message',
      on: {
        SUBMIT: { target: 'insubmission'},
        OVERRIDE: { target: 'override' },
        RE_INIT: {target: 'init'}
      }
    },
    insubmission: {
      invoke: {
        id: 'validate',
        src: 'validate_service',
        onDone: {
          target: 'valid',
          actions: (context, event) => {  }
        },
        onError: {
          target: 'invalid',
          actions: assign({ error: (context, event) => event.data })
        }
      }
    },
    invalid: {
      entry: 'validationFailed',
      on: {
        CHANGE: { target: 'filling' },
        INPUT: { target: 'filling' },
        OVERRIDE: { target: 'override' },
        RE_INIT: {target: 'init'}
        //CLOSE:  
        //check bootstrap to know what event gets called when a modal closes 
      }
    },
    valid: {
      entry: 'validationSucceeded',
      on: {
        PERFORM_ACTION: { target: 'inaction' }
      }
    },
    override: {
      on: {
        PERFORM_ACTION: { target: 'inaction' }
      }
    },
    inaction: {
      invoke: {
        id: 'action',
        src: 'action_service',
        onDone: {
          target: 'succeeded',
          actions: assign({
            data: (context, event)=> event.data,
            error: ()=> undefined
          })
        },
        onError: {
          target: 'failed',
          actions: assign({error: (context, event)=> event.data})
        }
      }
    },
    failed: {
      entry: 'actionFailed',
      on: {
        VALIDATION_FAILURE: { target: 'invalid'},
        CHANGE: { target: 'filling' },
        INPUT: { target: 'filling' },        
        SUBMIT: { target: 'insubmission'},
        PERFORM_ACTION: { target: 'inaction' },
        RE_INIT: {target: 'init'}
      }
    },
    succeeded: {
      entry: 'actionSucceeded',
      on: {
        LOAD_COMPLETE: { target: 'firstready' },
        RE_INIT: {target: 'init'}
      },
    },
    complete: {
      entry: 'final',
      type: 'final'
    }    
  }
},
{
  actions: {
    loaded: () => {},
    message: () => {},
    validationFailed: () => {},
    validationSucceeded: () => {},
    performAction: () => {},
    actionFailed: () => {},
    actionSucceeded: () => {},
    final: () => {},
  },
  services: {
    loading_service: () => {},
    validate_service: () => {},
    action_service: () =>{},
  }
}
);

const twoStepInvokeMachine = createMachine({
  id: 'twoStepInvoke',
  initial: 'idle',
  context: {
    first_data: undefined,
    second_data: undefined,
    error: undefined
  },
  states: {
    idle: {
      on: {
        FIRST: { target: 'firstaction' },   
      }
    },
    firstaction: {
      invoke: {
        id: 'firstaction',
        src: 'first_action_service',
        onDone: {
          target: 'secondaction',
          actions: assign({
            first_data: (context, event)=> event.data,
            error: ()=> undefined
          })
        },
        onError: {
          target: 'failed',
          actions: assign({error: (context, event)=> event.data})
        }
      }
    },
    secondaction: {
      invoke: {
        id: 'secondaction',
        src: 'second_action_service',
        onDone: {
          target: 'succeeded',
          actions: assign({
            second_data: (context, event)=> event.data,
            error: ()=> undefined
          })
        },
        onError: {
          target: 'failed',
          actions: assign({error: (context, event)=> event.data})
        }
      }
    },    
    failed: {
      entry: 'actionFailed',
      on: {
        FIRST: { target: 'firstaction' },
        SECOND: { target: 'secondaction' }
      }
    },
    succeeded: {
      entry: 'actionSucceeded',
      on: {
        IDLE: { target: 'idle' },   
      },
    },
    complete: {
      entry: 'final',
      type: 'final'
    }    
  }
},
{
  actions: {
    actionFailed: () => {},
    actionSucceeded: () => {},
    final: () => {},
  },
  services: {
    first_action_service: () =>{},
    second_action_service: () =>{},
  }
}
);

const threeStepInvokeMachine = createMachine({
  id: 'threeStepInvoke',
  initial: 'idle',
  context: {
    first_data: undefined,
    second_data: undefined,
    thrid_data: undefined,
    error: undefined
  },
  states: {
    idle: {
      on: {
        FIRST: { target: 'firstaction' },   
      }
    },
    firstaction: {
      invoke: {
        id: 'firstaction',
        src: 'first_action_service',
        onDone: {
          target: 'secondaction',
          actions: assign({
            first_data: (context, event)=> event.data,
            error: ()=> undefined
          })
        },
        onError: {
          target: 'failed',
          actions: assign({error: (context, event)=> event.data})
        }
      }
    },
    secondaction: {
      invoke: {
        id: 'secondaction',
        src: 'second_action_service',
        onDone: {
          target: 'thirdaction',
          actions: assign({
            second_data: (context, event)=> event.data,
            error: ()=> undefined
          })
        },
        onError: {
          target: 'failed',
          actions: assign({error: (context, event)=> event.data})
        }
      }
    },
    thirdaction: {
      invoke: {
        id: 'thirdaction',
        src: 'third_action_service',
        onDone: {
          target: 'succeeded',
          actions: assign({
            third_data: (context, event)=> event.data,
            error: ()=> undefined
          })
        },
        onError: {
          target: 'failed',
          actions: assign({error: (context, event)=> event.data})
        }
      }
    },       
    failed: {
      entry: 'actionFailed',
      on: {
        FIRST: { target: 'firstaction' },
        SECOND: { target: 'secondaction' },
        THIRD: { target: 'thirdaction' }
      }
    },
    succeeded: {
      entry: 'actionSucceeded',
      on: {
        IDLE: { target: 'idle' },   
      },
    },
    complete: {
      entry: 'final',
      type: 'final'
    }    
  }
},
{
  actions: {
    actionFailed: () => {},
    actionSucceeded: () => {},
    final: () => {},
  },
  services: {
    first_action_service: () =>{},
    second_action_service: () =>{},
    third_action_service: () =>{},
  }
}
);


export {threeStepInvokeMachine};
export {twoStepInvokeMachine};
export {simpleInvokeMachine};
export {fullLoadingInvokeMachine};
export {fullInvokeMachine};
export {interpret};
export {passwordLoginUser};
export {socialLoginUser};
export {socialSignupUser};

